import NavBar from "../NavBar/NavBar";
import styles from "./Header.module.scss"

export default function Header(){
    return(
        <>
        <header className={styles.header}>
            <NavBar/>
        </header>
        
        </>
    );
}   